@if (!commonQuestionnaireService.createMode) {
<div>
    @if (question.title) {
    <div class="title overflow-break-word full-width">
        <span>{{ question.number + 1 }}</span>
        <span [ngClass]="{ required: question.required && customerQuestionnaireService.displayVersion === 'full' }">
            {{ '. ' + question.title }}</span
        >
    </div>
    } @if (question.description) {
    <div class="description full-width m-t-5">
        {{ question.description }}
    </div>
    } @if (currentAnswer) {
    <div class="answer-body-container full-width m-t-32">
        @for (field of currentAnswer; track field) {
        <div>
            @if (field.type === 'input') {
            <div class="d-flex align-baseline space-between">
                <p class="field-label text-ellipsis width-p-40">{{ field.label }}</p>
                <mat-form-field
                    appearance="outline"
                    class="input-form-field width-p-60"
                >
                    <input
                        [(ngModel)]="field.answer"
                        (ngModelChange)="onInputValueChanged($event)"
                        [placeholder]="field.placeholder"
                        [disabled]="commonQuestionnaireService.reviewMode && questionReview?.notification_type !== 'modify'"
                        matInput
                        required
                        maxlength="255"
                        type="text"
                    />
                </mat-form-field>
            </div>
            } @if (field.type === 'select') {
            <div class="d-flex align-baseline space-between">
                <p class="field-label text-ellipsis width-p-40">{{ field.label }}</p>
                <mat-form-field
                    appearance="outline"
                    class="input-form-field width-p-60"
                >
                    <mat-select
                        [(value)]="field.answer"
                        placeholder="Select"
                        [matTooltip]="field.answer"
                        (selectionChange)="onSelectionChanged($event)"
                        [disabled]="commonQuestionnaireService.reviewMode && questionReview?.notification_type !== 'modify'"
                        disableOptionCentering
                    >
                        @for (option of field.options; track option) {
                        <mat-option
                            class="customer-view"
                            [value]="option"
                        >
                            {{ option }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            }
        </div>
        }
    </div>
    }
    <app-question-footer
        (questionMarked)="onQuestionMarked($event)"
        [showOk]="hasCompletedForm()"
        [question]="question"
        [questionIndex]="questionIndex"
    ></app-question-footer>
</div>
} @if (commonQuestionnaireService.createMode) {
<div class="question-create-panel">
    @if (formGroup) {
    <form [formGroup]="formGroup.group">
        <div class="title no-border full-width">
            <div class="full-width input-form-field questionTitle m-t-10">
                @if (question.title) {
                <div class="title-number w-10-percent">
                    <mat-form-field
                        appearance="outline"
                        class="full-width title-input input-form-field"
                    >
                        <textarea
                            disabled
                            matInput
                            type="text"
                            class="title-textarea m-t-0 resize-none"
                            >{{ questionTitle }}</textarea
                        >
                    </mat-form-field>
                </div>
                }
                <div class="m-l--10">
                    <mat-form-field
                        appearance="outline"
                        class="title-input full-width input-form-field"
                    >
                        <textarea
                            (ngModelChange)="onTitleChange()"
                            #titleTextarea
                            [placeholder]="questionPlaceholder"
                            cdkAutosizeMaxRows="5"
                            cdkAutosizeMinRows="1"
                            cdkTextareaAutosize
                            formControlName="title"
                            matInput
                            class="title-textarea m-t-0"
                            required
                            type="text"
                        ></textarea>
                        @if (TitleControl?.invalid) {
                        <mat-error>
                            <span>{{ formGroup.getReadableError('title') }}</span>
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="description text-left fs-13 m-t-7 no-border full-width full-height">
            <mat-form-field
                appearance="outline"
                class="full-width input-form-field"
            >
                <textarea
                    (ngModelChange)="onDescriptionChange()"
                    [placeholder]="descriptionPlaceholder"
                    cdkAutosizeMaxRows="5"
                    cdkAutosizeMinRows="1"
                    class="description-textarea"
                    maxlength="1000"
                    cdkTextareaAutosize
                    formControlName="description"
                    matInput
                    type="text"
                ></textarea>
            </mat-form-field>
        </div>
        @if (currentAnswer) {
        <div class="answer-body-container full-width">
            @for (field of currentAnswer; track field; let fieldIndex = $index) {
            <div>
                @if (field.type === 'input') {
                <div class="d-flex-center space-between">
                    <mat-form-field
                        appearance="outline"
                        class="full-width no-border input-form-field small-input m-t-10"
                    >
                        <input
                            (ngModelChange)="onLabelChange(field, fieldIndex, field.type)"
                            [formControlName]="'option_' + field.type + '_' + fieldIndex + '_label'"
                            [placeholder]="answerInputPlaceholder"
                            class="field-label font-italic text-ellipsis"
                            matInput
                            required
                            maxlength="100"
                            type="text"
                        />
                        @if (getOptionControl(fieldIndex, 'input', 'label')?.invalid) {
                        <mat-error class="text-left p-t-2 p-l-2">
                            <span>{{ formGroup.getReadableError('option_' + field.type + '_' + fieldIndex + '_label') }}</span>
                        </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field no-error-input width-p-60 m-t-10"
                    >
                        <input
                            [(ngModel)]="field.placeholder"
                            [ngModelOptions]="{ standalone: true }"
                            [placeholder]="answerInputPlaceholder"
                            class="font-italic text-left"
                            matInput
                            maxlength="50"
                            type="text"
                        />
                    </mat-form-field>
                    <button
                        [disabled]="!cstQuestionnaireService.checkMinRequirements(currentAnswer, MIN_ROWS)"
                        [ngClass]="{ 'btn-disabled': !cstQuestionnaireService.checkMinRequirements(currentAnswer, MIN_ROWS) }"
                        class="inline-block m-l-16"
                        disableRipple
                        mat-icon-button
                        matSuffix
                        (click)="deleteField(fieldIndex)"
                    >
                        <mat-icon class="cancel-btn fs-18"> cancel</mat-icon>
                    </button>
                </div>
                } @if (field.type === 'select') {
                <div
                    class="d-flex-center space-between"
                    id="select-div"
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width no-border input-form-field small-input m-t-10"
                    >
                        <input
                            (ngModelChange)="onLabelChange(field, fieldIndex, field.type)"
                            [formControlName]="'option_' + field.type + '_' + fieldIndex + '_label'"
                            [placeholder]="answerSelectPlaceholder"
                            class="field-label font-italic text-ellipsis"
                            matInput
                            maxlength="100"
                            required
                            type="text"
                        />
                        @if (getOptionControl(fieldIndex, 'select', 'label')?.invalid) {
                        <mat-error class="text-left p-t-2 p-l-2">
                            <span>{{ formGroup.getReadableError('option_' + field.type + '_' + fieldIndex + '_label') }}</span>
                        </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field no-error-input width-p-60 m-t-10"
                    >
                        <mat-select
                            (selectionChange)="changeSelectionEvent($event)"
                            [placeholder]="'Select'"
                            class="text-left"
                            disableOptionCentering
                        >
                            @for (option of field.options; track trackByFn(i, option); let i = $index) {
                            <mat-option
                                [value]="option"
                                class="cst-view"
                            >
                                <div class="d-flex-center justify-space-around">
                                    @if (field.options) {
                                    <input
                                        (click)="$event.stopPropagation()"
                                        (keydown)="$event.stopPropagation()"
                                        (ngModelChange)="onSelectOptionChange(i, fieldIndex)"
                                        [formControlName]="'option_' + field.type + '_' + fieldIndex + '_opt_' + i"
                                        [placeholder]="'Type option ' + (i + 1) + ' here'"
                                        class="font-italic text-left dropdown-input"
                                        matInput
                                        required
                                        maxlength="50"
                                        type="text"
                                    />
                                    }
                                    <button
                                        [disabled]="!validateMinOptions(field)"
                                        [ngClass]="{ 'btn-disabled': !validateMinOptions(field) }"
                                        (click)="deleteOption($event, field, fieldIndex, i)"
                                        class="inline-block"
                                        disableRipple
                                        mat-icon-button
                                        matSuffix
                                    >
                                        <mat-icon class="cancel-btn fs-18">cancel</mat-icon>
                                    </button>
                                </div>
                            </mat-option>
                            }
                            <mat-option class="add-option">
                                <div
                                    class="add-option-inner fr"
                                    (click)="addOption($event, fieldIndex, field)"
                                >
                                    <p class="add-btn fs-12">Add option</p>
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button
                        [disabled]="!cstQuestionnaireService.checkMinRequirements(currentAnswer, MIN_ROWS)"
                        [ngClass]="{ 'btn-disabled': !cstQuestionnaireService.checkMinRequirements(currentAnswer, MIN_ROWS) }"
                        (click)="deleteField(fieldIndex)"
                        class="inline-block m-l-16"
                        disableRipple
                        mat-icon-button
                        matSuffix
                    >
                        <mat-icon class="cancel-btn fs-18">cancel</mat-icon>
                    </button>
                </div>
                }
            </div>
            }
        </div>
        }
    </form>
    }
    <div class="d-flex-center justify-end edit-mode-question-footer m-t-10">
        <p
            (click)="addNewField('input')"
            class="add-btn left-btn fs-12 p-t-1 p-l-15 p-r-15 p-b-1"
        >
            Add text input
        </p>
        <p
            (click)="addNewField('select')"
            class="add-btn fs-12 p-t-1 p-l-15 p-b-1"
        >
            Add dropdown
        </p>
    </div>
    <div class="m-auto">
        @if (!areAllOptionsForSelectCompleted()) {
        <mat-error style="text-align: center">
            <span>All select options must contain text.</span>
        </mat-error>
        }
    </div>
</div>
}
